module.exports = __webpack_public_path__ + "img/LA.1d648980.svg";